module.exports = __webpack_public_path__ + "static/media/mini.2436da28.png";